import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PerformanceMetrics } from '@app/models/dashboard.models';

@Component({
  selector: 'app-performance-metrics-card',
  templateUrl: './performance-metrics-card.component.html',
  styleUrl: './performance-metrics-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PerformanceMetricsCardComponent {
  @Input() metrics: PerformanceMetrics | null = null;

  getProductionChange(): number {
    if (!this.metrics) return 0;
    if (this.metrics.productionLastMonth === 0) return 0;
    return ((this.metrics.productionThisMonth - this.metrics.productionLastMonth) / this.metrics.productionLastMonth) * 100;
  }

  getMachineEfficiencyChange(): number {
    if (!this.metrics) return 0;
    return this.metrics.machineEfficiency - this.metrics.machineEfficiencyLastMonth;
  }

  getQualityRejectionChange(): number {
    if (!this.metrics) return 0;
    return this.metrics.qualityRejectionRate - this.metrics.qualityRejectionRateLastMonth;
  }

  getChangeColor(value: number): string {
    return value >= 0 ? 'positive' : 'negative';
  }
}
